/* -------------------------------------------------------------------------- */
/*                                   TITLES                                   */

const create = {
	complete: {
		overview: {
			account_row_title: "daDup Storage Account",
			desc: "Review the summary of the daDup Storage Account you are about to order.",
			description: "Description",
			relation: "Relation",
			title: "Configuration Overview",
		},
		page_title: "daDup Account Order Summary",
		product_details_desc: "Update your daDup Storage Account details here.",
		product_details_title: "daDup Storage Account Details",
		product_header_title: "Product Overview",
		product_title: "daDup Storage Account",
		submit_button: "Create",
		success_toast: "daDup created successfully!",
	},
	config: {
		description: "Choose a name for your daDup account.",
		placeholder_description: "Optional description",
		placeholder_description_helper: "Provide a description for your daDup account.",
		section_label: "daDup Account Information.",
		title: "daDup Account Configuration",
	},
	header: "Create daDup Account",
	kind: {
		description: "Choose the daDup account type.",
		options: {
			default: "S3 Storage",
			disabled_text: "This is not available",
		},
		title: "daDup Account Type",
	},
	other_info: {
		description:
			"Optionally choose a relation to link this account to. Linking a relation does not affect functionality. You can also link other products to a relation to see everything a relation uses",
		options: {
			enabled: "Link to relation",
		},
		section_label: "Link to relation",
		title: "Other information",
	},
};

export default create;
